// Chat bubble used in the hero animated mockup.
import type { ReactNode } from "react";

import { Mascot, type MascotName } from "./Mascot";

type BubbleProps = {
  who: "user" | "ai";
  children: ReactNode;
  visible?: boolean;
  delay?: number;
  compact?: boolean;
  mascot?: MascotName;
};

export function Bubble({
  who,
  children,
  visible = true,
  delay = 0,
  compact = false,
  mascot = "Sage",
}: BubbleProps) {
  const isUser = who === "user";

  return (
    <div
      style={
        {
          "--bubble-delay": `${delay}ms`,
        } as React.CSSProperties
      }
      className={`flex transition-[opacity,transform] duration-500 ease-[ease] delay-[var(--bubble-delay)] ${
        isUser ? "justify-end" : "justify-start"
      } ${compact ? "mb-2" : "mb-3.5"} ${
        visible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
      }`}
    >
      {!isUser && (
        <div className="mr-2.5 h-8 w-8 shrink-0 overflow-hidden rounded-full shadow-[0_1px_4px_-1px_rgba(67,56,202,0.25)]">
          <Mascot name={mascot} size={32} />
        </div>
      )}
      <div
        className={`flex max-w-[78%] flex-col ${
          isUser ? "items-end" : "items-start"
        }`}
      >
        {!isUser && (
          <div className="mb-1 ml-0.5 text-[10.5px] font-bold uppercase tracking-[0.08em] text-indigo-700">
            {mascot}
          </div>
        )}
        <div
          className={`cursor-default font-body text-sm leading-[1.5] transition-[box-shadow,transform,border-color] duration-300 ease-[ease] ${
            isUser
              ? "chat-bubble chat-bubble--user rounded-[18px_18px_4px_18px] border-0 bg-indigo-500 text-white shadow-[0_4px_14px_-6px_rgba(99,102,241,0.55)]"
              : "chat-bubble chat-bubble--ai rounded-[18px_18px_18px_4px] border border-grindigo-100 bg-white text-primary shadow-[0_2px_10px_-4px_rgba(99,102,241,0.18)]"
          } px-3.5 py-2.5`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
